import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";

export class planningRouteSuggestionsTimelineItemsCtrl implements IController {
  services: any;
  selectedIds: any;
  onSelect: Function;


  public limit: number = 10;
  public offSet: number = 0;
  public displayedServices: any;

  constructor() {
  }

  $onInit() {
    this.offSet = 0;
    this.displayedServices = _.take(this.services, this.limit);
  }

  $onChanges(changes) {
    if (changes.services && !changes.services.isFirstChange()) {
      this.$onInit();
    }
  };

  isSuggestionSelected(service) {
    return _.includes(this.selectedIds, service.id);
  }

  onNext() {
    this.offSet = this.offSet + this.limit;
    this.displayedServices = _.slice(this.services, this.offSet, (this.offSet + this.limit));
  }

  onPrev() {
    this.offSet = this.offSet - this.limit;
    this.displayedServices = _.slice(this.services, this.offSet, (this.offSet + this.limit));
  }

  getAllDraggedSuggestions(draggedService) {
    var isDraggedSelected = this.isSuggestionSelected(draggedService);
    return isDraggedSelected ?
      _.filter(this.services, (s) => {
        return _.includes(this.selectedIds, s.id);
      }) : [draggedService]
  }

  onSuggestionsDragStart(event, draggedService) {
    var draggedItems = this.getAllDraggedSuggestions(draggedService);
    var suggestionItems = _.map(draggedItems, (s) => {
      return {
        content: 'Suggestion',
        id: s.id,
        type: s.serviceType
        // type: 'STOP'
      }
    });
    event.originalEvent.dataTransfer.setData('text', JSON.stringify({
      content: 'Suggestions',
      items: suggestionItems
    }));
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteSuggestionsTimelineItems', {
    bindings: {
      services: '<',
      selectedIds: '<',
      onSelect: '&'
    },
    template: require('./planning-route-suggestions-timeline-items.html').default,
    controller: planningRouteSuggestionsTimelineItemsCtrl
  });
